define('errorToolTip', [
    'jquery'
], function($) {
    $(function() {
        window.$errorTooltip = $('.error_tooltip');

        $('.js-close-button').click(function() {
            if (window.$errorTooltip.length) {
                window.$errorTooltip.hide();
            }
        });
    });

    return function($from, left_side, msg, addTermsClass) {
        let erOw;
        let fromOff;

        if (typeof $from === 'undefined' || !$from.length) {
            console.error('arg `from` empty');
        }

        window.$errorTooltip.removeClass('left right terms');

        if (left_side) {
            window.$errorTooltip.addClass('right');
        } else {
            window.$errorTooltip.addClass('left');
        }

        if (addTermsClass) {
            window.$errorTooltip.addClass('terms');
        }

        window.$errorTooltip.html(msg);

        fromOff = $from.offset();
        erOw = window.$errorTooltip.outerHeight();

        if (left_side) {
            window.$errorTooltip.css({
                top: fromOff.top + (($from.outerHeight() - erOw) / 2),
                left: fromOff.left - (window.$errorTooltip.outerWidth() + 10)
            });
        } else {
            window.$errorTooltip.css({
                top: fromOff.top + (($from.outerHeight() - erOw) / 2),
                left: fromOff.left + $from.outerWidth() + 10
            });
        }

        window.$errorTooltip.show();
    };
});
